import { Link, Navigate, Outlet, useLocation } from 'react-router'
import { useThemeColor } from '../hooks/StatusBarColorPicker'
import { InstallPrompt } from './InstallPrompt'
import { WebsiteHeader, WebsiteHeaderSpacer } from './WebsiteHeader'

const WEBSITE_ALLOWED_PATHS = new Set([
  '/home',
  '/application-of-interest',
  '/nda',
  '/application-status',
])

export function WebsiteShell() {
  const location = useLocation()
  useThemeColor('#FFFFFF')

  const meetingsEnabled = import.meta.env.VITE_MEETINGS_ENABLED === 'true'
  const meetingPath = meetingsEnabled && ['/training', '/calendar'].includes(location.pathname)

  if (!WEBSITE_ALLOWED_PATHS.has(location.pathname) && !meetingPath) {
    return <Navigate to="/home" replace />
  }

  return (
    <div className="min-h-dvh bg-gray-50">
      <WebsiteHeader />
      <main className="min-h-dvh">
        <WebsiteHeaderSpacer />
        <div className="mx-auto w-full max-w-screen-sm md:max-w-4xl">
          <InstallPrompt className="px-4 py-3" />
          {meetingsEnabled && <nav aria-label="Meetings" className="flex gap-4 px-4 py-3">
            <Link to="/home">Home</Link><Link to="/training">Meetings</Link><Link to="/calendar">Calendar</Link>
          </nav>}
          <Outlet />
        </div>
      </main>
    </div>
  )
}
